import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import SalesCatalystMediaPackageInput from './SalesCatalystMediaPackageInput';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import upArrow from '../../../images/up-arrow_78-14-40.png';
import SalesCatalystMediaPackageImageBlock from './SalesCatalystMediaPackageImageBlock';
import { SC_TARGET_REPORT, SC_TARGET_ENTITY_REPORT, SC_TARGET_BRAND_REPORT, SC_TARGET_ENTITY_BRAND_REPORT, SC_PACKAGE_CHARTS } from '../../../constants';
import downArrow from '../../../images/down-arrow_78-14-40.png';


class SalesCatalystMediaPackage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentDidMount() {
    const { targetOnScreen, graphData,
      getMediaPackageBarChartData, dataOnScreenTarget, dataSelection } = this.props;

    if (targetOnScreen && _.isEmpty(graphData.scTarget)) {
      getMediaPackageBarChartData(SC_TARGET_REPORT);
    }
    if (targetOnScreen && _.isEmpty(graphData.scTargetEntity)) {
      getMediaPackageBarChartData(SC_TARGET_ENTITY_REPORT);
    }
    if (dataOnScreenTarget.mediaPackage && !_.isEmpty(dataSelection.brand)
      && _.isEmpty(graphData.scTargetBrand) && _.isEmpty(graphData.scTargetEntityBrand)) {
      getMediaPackageBarChartData(SC_TARGET_ENTITY_BRAND_REPORT);
      getMediaPackageBarChartData(SC_TARGET_BRAND_REPORT);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { targetOnScreen, dataOnScreenTarget,
      dataSelection, getMediaPackageBarChartData,
      selectedList } = this.props;
    if (!targetOnScreen && nextProps.targetOnScreen) {
      getMediaPackageBarChartData(SC_TARGET_REPORT);
      getMediaPackageBarChartData(SC_TARGET_ENTITY_REPORT);
    }
    if (!dataOnScreenTarget.mediaPackage && nextProps.dataOnScreenTarget.mediaPackage) {
      if (!_.isEmpty(dataSelection.brand)) {
        getMediaPackageBarChartData(SC_TARGET_ENTITY_BRAND_REPORT);
        getMediaPackageBarChartData(SC_TARGET_BRAND_REPORT);
      }
    }

    if (selectedList !== nextProps.selectedList) {
      if (!_.isEmpty(dataSelection.targetEntityOverlap)) {
        getMediaPackageBarChartData(SC_TARGET_REPORT);
        getMediaPackageBarChartData(SC_TARGET_ENTITY_REPORT);
      }
      if (!_.isEmpty(dataSelection.brand) && dataOnScreenTarget.mediaPackage) {
        getMediaPackageBarChartData(SC_TARGET_ENTITY_BRAND_REPORT);
        getMediaPackageBarChartData(SC_TARGET_BRAND_REPORT);
      }
    }
  }

  render() {
    const { renderInitialScreen } = this.props;
    return (
      <div>
        {this.props.scMediaPackageInputFlag === true &&
          <div>
            <div className="sc-panel-width">
              <SalesCatalystMediaPackageInput
                renderInitialScreen={!renderInitialScreen}
                color={this.props.color}
              />
            </div>
          </div>
        }
        {this.props.dataOnScreenTarget.mediaPackage === true &&
          <div>
            <div className="row"><span onClick={this.props.scMediaPackageCollapse}>
              <img
                alt="Up Arrow"
                src={this.props.scMediaPackageInputFlag === true ? upArrow : downArrow}
                className="media-package-collapse"
              />
            </span>
            </div>
            <div className="media-package-devison-line">&nbsp;</div>
          </div>
        }
        <div>&nbsp;</div>
        <div className="large-12 medium-12 small-12 columns mediaPackageImageBlockDiv panel-layout-padding">
          <SalesCatalystMediaPackageImageBlock />
        </div>

      </div>
    );
  }
}

SalesCatalystMediaPackage.propTypes = {
  graphData: PropTypes.shape({}),
  salesCatalystActions: PropTypes.shape({
    setMediaPackageInputFlag: PropTypes.func,
  }),
  targetOnScreen: PropTypes.bool,
  getMediaPackageBarChartData: PropTypes.func,
  dataSelection: PropTypes.arrayOf(PropTypes.object),
  dataOnScreenTarget: PropTypes.shape({}),
  selectedList: PropTypes.shape({}),
  renderInitialScreen: PropTypes.bool,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    scMediaPackageInputFlag: state.salesCatalyst.scMediaPackageInputFlag,
    dataSelection: state.salesCatalyst.dataSelection,
    targetOnScreen: state.salesCatalyst.dataOnScreen.targetMarket,
    graphData: state.salesCatalyst.graphData,
    dataOnScreenTarget: state.salesCatalyst.dataOnScreen,
    selectedList: state.salesCatalyst.scConfiguration.package.selectedList,
    renderInitialScreen: state.salesCatalyst.dataSelection.brand.length > 0 || false,
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const scMediaPackageCollapse = () => {
    dispatch(salesCatalystActions.setMediaPackageInputFlag(!stateProps.scMediaPackageInputFlag));
  };

  const getMediaPackageBarChartData = (report, vpctFilter = 0, top, minSampleSize,
    chartType = SC_PACKAGE_CHARTS) => {
    if (stateProps.dataSelection.entity.length > 0 &&
      stateProps.dataSelection.targetMarket.length > 0) {
      const productNo = stateProps.productNo;
      const token = stateProps.loginResponse.data.token;
      const uid = stateProps.loginResponse.data.uid;
      const accountId = stateProps.activeAccountId;
      const reportName = report;
      const targetLabel = stateProps.dataSelection.targetMarket[0].label;
      const targetExpression = stateProps.dataSelection.targetMarket[0].expression;
      const entityLabel = stateProps.dataSelection.entity[0].label;
      const entityExpression = stateProps.dataSelection.entity[0].expression;
      const brandLabel = stateProps.dataSelection.brand.length !== 0 ?
        stateProps.dataSelection.brand[0].label : '';
      const brandExpression = stateProps.dataSelection.brand.length !== 0 ?
      stateProps.dataSelection.brand[0].expression : '';

      dispatch(salesCatalystActions.getBarChartReport({
        uid,
        accountId,
        token,
        reportName,
        productNo,
        targetLabel,
        targetExpression,
        entityLabel,
        entityExpression,
        brandLabel,
        brandExpression,
        vpctFilter,
        top,
        minSampleSize,
        chartType,
      }));
    }
  };

  return Object.assign({}, stateProps, ownProps, {
    scMediaPackageCollapse,
    getMediaPackageBarChartData,
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystMediaPackage);
